export const MIMETYPES = {
	PDF: 'application/pdf',
	CSV: 'text/csv',
	XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
